import { pick } from 'lodash'

export const transformPriorityTaskToCreateArgs = values =>
  pick(values, [
    'name',
    'description',
    'kpi',
    'allocationType',
    'customRequiredDishCount',
    'priority',
  ])
